<template>
  <HgNotificationMessage
    :title="t('contactForm.contacted.date', { date: contactedDate }).toString()"
    theme="info"
  >
    <p v-if="showDescription">{{ t('contactForm.contacted.text') }}</p>
  </HgNotificationMessage>
</template>

<script lang="ts" setup>
import { HgNotificationMessage } from '@smg-real-estate/domus';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineOptions({
  name: 'ContactedOnMessage',
});

export interface Props {
  showDescription?: boolean;
  contactedDate: string;
}

withDefaults(defineProps<Props>(), {
  showDescription: true,
});
</script>
